import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Popover from '@material-ui/core/Popover';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

class InsulationWarningComponent extends Component {
  state = {
    popover: false,
    popoverAnchorEl: null,
  };

  toggleWarnings = (event) => {
    const anchorEl = event && event.currentTarget ? event.currentTarget : null;
    this.setState((prev) => {
      if (prev.popover) {
        return { popover: false, popoverAnchorEl: null };
      }
      return { popover: true, popoverAnchorEl: anchorEl };
    });
  };

  closeWarnings = () => {
    this.setState({ popover: false, popoverAnchorEl: null });
  };

  handleClickAway = (event) => {
    if (!this.state.popover) {
      return;
    }

    const { popoverAnchorEl } = this.state;
    if (popoverAnchorEl && popoverAnchorEl.contains(event.target)) {
      return;
    }

    this.closeWarnings();
  };

  render() {
    const {object = false, cladding = false, warnings = [], disableAnimation = false} = this.props;

    const items = warnings.map( (item, index)=> {
      return <li key={`${item}-${index}`}>{item}</li>;
    });

    return (
      <React.Fragment>
        <button
          type="button"
          className={
            'warning-icon ' +
            (disableAnimation ? '' : 'animated fadeIn ') +
            (cladding ? 'cladding' : '') +
            (object ? 'object' : '')
          }
          onClick={this.toggleWarnings}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') this.toggleWarnings(e);
          }}
        >
          <i className="fa fa-exclamation-triangle" aria-hidden="true" />
        </button>
        <Popover
          open={this.state.popover}
          anchorEl={this.state.popoverAnchorEl}
          onClose={this.closeWarnings}
        >
          <ClickAwayListener onClickAway={this.handleClickAway}>
            <div className="layer-warnings" onClick={this.closeWarnings}>
              <ul>
                {items}
              </ul>
            </div>
          </ClickAwayListener>
        </Popover>
      </React.Fragment>
    );
  }
}

InsulationWarningComponent.propTypes = {

  object: PropTypes.any,
  cladding: PropTypes.any,
  warnings: PropTypes.any,
  disableAnimation: PropTypes.bool,
};

export default InsulationWarningComponent;
